import type { OrderStatus } from '@scan2eat/shared';

import { labels } from '../labels.js';

/** Badge variant per status: .badge--* classes in styles/global.css, docs/15 section 2.3. */
const VARIANT: Record<OrderStatus, string> = {
  PENDING: 'pending',
  IN_PREPARATION: 'preparing',
  ON_HOLD: 'hold',
  READY: 'ready',
  SERVED: 'served',
  COMPLETED: 'served',
  CANCELLED: 'cancelled',
};

export function StatusBadge({ status }: { status: OrderStatus }) {
  return <span className={`badge badge--dot badge--${VARIANT[status]}`}>{labels.status[status]}</span>;
}
